export const contactUs = "contactUs";
export const affiliateRoute = `${contactUs}/affiliate`;
export const trainerRoute = `${contactUs}/trainer`;
export const infoRoute = `${contactUs}/info`;
